import React, { useContext, useState } from 'react'
import "./navbar.css"
import { assets } from '../../assets/assets'
import { Link } from 'react-router-dom';
import { StoreContext } from '../../context/StoreContext';

function NavBar(props) {
  const { setShowLogin } = props;
  const [menu, setMenu] = useState("home");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { getTotalCartAmount } = useContext(StoreContext);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className='navbar'>
      <Link to="/">
        <span className='app-title'>Food App.</span>
      </Link>
      <ul className={`navbar-menu ${isMobileMenuOpen ? "open" : ""}`}>
        <Link to="/" onClick={() => { setMenu("home"); toggleMobileMenu(); }} className={menu === "home" ? "active" : ""}>Home</Link>
        <a href='#explore-menu' onClick={() => { setMenu("menu"); toggleMobileMenu(); }} className={menu === "menu" ? "active" : ""}>Menu</a>
        <a href='#appDownload' onClick={() => { setMenu("mobile-app"); toggleMobileMenu(); }} className={menu === "mobile-app" ? "active" : ""}>Mobile App</a>
        <a href='#footer' onClick={() => { setMenu("contact-us"); toggleMobileMenu(); }} className={menu === "contact-us" ? "active" : ""}>Contact Us</a>
      </ul>
      <div className="navbar-right">
        <img src={assets.search_icon} className='search-icon' alt="Search" />
        <div className="navbar-search-icon">
          <Link to="/cart">
            <img src={assets.basket_icon} alt="Cart" />
          </Link>
          <div className={getTotalCartAmount() ? "dot" : ""}></div>
        </div>
        <button onClick={() => setShowLogin(true)}>Sign in</button>
        <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
          <div className={`bar ${isMobileMenuOpen ? "open" : ""}`}></div>
          <div className={`bar ${isMobileMenuOpen ? "open" : ""}`}></div>
          <div className={`bar ${isMobileMenuOpen ? "open" : ""}`}></div>
        </div>
      </div>
    </div>
  )
}

export default NavBar
